import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { FormInput, FormNumber, FormSelect } from '.';
import { communes, provinces, regions } from '../helpers/demographics';
import validate from '../helpers/emitContactInformationValidate';
import focusInputOnError from '../helpers/focusInputOnError';
import { parseStringToNumber } from '../helpers/utils';
import { env } from '../env';

const regionsOptions = regions.map((region: any) => ({
  name: region.name,
  value: region.code,
}));

export function EmitContactInformationForm(props: any) {
  const {
    handleSubmit,
    previousPage,
    initialValues: {province, region },
  } = props;
  const [provincesOptions, setProvincesOptions] = useState([]);
  const [communesOptions, setCommunesOptions] = useState([]);

  const handleRegionChange = ({ target: { value: regionCode } }: any) => {
    setCommunesOptions([]);

    const options: any = provinces
      .filter((province: any) => province.region_code === regionCode)
      .map((province: any) => ({ name: province.name, value: province.code }));

    setProvincesOptions(options);
  };

  const handleProvinceChange = ({ target: { value: provinceCode } }: any) => {
    const options: any = communes
      .filter((commune: any) => commune.province_code === provinceCode)
      .map((commune: any) => ({ name: commune.name, value: commune.code }));

    setCommunesOptions(options);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvContactInfo',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);

      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/informacion-de-contacto',
        title: 'Seguro Salud Complementario',
        user_id: sessionStorage.getItem('userId'),
      });
      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-informacion-contacto'
      }); 
      
    }
  }, []);

  useEffect(() => {
    if (region) {
      handleRegionChange({ target: { value: region } });
      if (province) {
        handleProvinceChange({ target: { value: province } });
      }
    }
  }, [province, region]);

  return (
    <form onSubmit={handleSubmit} noValidate={true}>
      <div className="row justify-content-center flex-column mb-70">
        <div className="col-12 col-sm-8 col-md-7 col-lg-5 mx-auto text-center">
          <h3 className="wizard-card--title px-24">Información de contacto</h3>
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="email">Correo</label>
          <Field name="email" placeholder="Correo" component={FormInput} disabled={true}/>
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="phone">Teléfono</label>
          <Field
            name="phone"
            placeholder="9 9999 9999"
            inputFormat="# #### ####"
            component={FormNumber}
            autoFocus={true}
            isPhone={true}
          />
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="address">Dirección</label>
          <Field
            name="address"
            component={FormInput}
            placeholder="Ej. Avenida Libertador Bernardo O’Higgins"
          />
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="addressNumber">Número</label>
          <Field
            name="addressNumber"
            placeholder="Ej. 1234"
            inputFormat="#####"
            normalize={parseStringToNumber}
            component={FormNumber}
          />
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="region">Región</label>
          <Field
            name="region"
            options={regionsOptions}
            placeholder="Selecciona..."
            component={FormSelect}
            onChange={handleRegionChange}
            isDisabled={!regionsOptions.length}
          />
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="province">Provincia</label>
          <Field
            name="province"
            options={provincesOptions}
            placeholder="Selecciona..."
            component={FormSelect}
            onChange={handleProvinceChange}
            isDisabled={!provincesOptions.length}
          />
        </div>
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 mx-auto form-group">
          <label htmlFor="commune">Comuna</label>
          <Field
            name="commune"
            options={communesOptions}
            placeholder="Selecciona..."
            component={FormSelect}
            isDisabled={!communesOptions.length}
          />
        </div>
      </div>
      <footer className="fixed-footer-form emit-steps">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6 pdy-16 d-flex justify-content-between align-content-center align-items-center">
              <button
                className="btn white back-to-matrix col-4 d-flex justify-content-center align-content-center align-items-center"
                type="button"
                onClick={previousPage}
              >
                <i className="material-icons">chevron_left</i>
              </button>
              <button
                className="btn primary go-to-contact-info col-8"
                type="submit"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
  );
}

export default withRouter(
  reduxForm<any, any>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'proposal',
    onSubmitFail: focusInputOnError,
    validate,
  })(EmitContactInformationForm),
);
